module.exports = __webpack_public_path__ + "static/media/tractor.2ea8bd3d.mp4";